import React, { useEffect, useState, useRef } from "react";
import api from "../../core/api/config";
import { MessageCircle } from "feather-icons-react/build/IconComponents";

const BotaoSuporte = () => {
  const [aberto, setAberto] = useState(false);
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ assunto: "", mensagem: "" });
  const [arquivo, setArquivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [chamadoCriado, setChamadoCriado] = useState(null);
  const inputFileRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    api
      .get("/api/user/show", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setUser(response.data.user); // aqui está o nome, email e id
      })
      .catch((error) => {
        console.error("Erro ao buscar dados do usuário:", error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleFileChange = (e) => {
    setArquivo(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setChamadoCriado(null);

    const formData = new FormData();
    formData.append("assunto", form.assunto);
    formData.append("mensagem", form.mensagem);
    formData.append("usuarioId", user?.id || "");
    formData.append("statusChamadoId", 1);
    if (arquivo) formData.append("arquivo", arquivo);

    const token = localStorage.getItem("token");

    try {
      const response = await api.post("/api/tracking/chamados", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      setChamadoCriado(response.data); // <- dados retornados
      setAberto(false);
      setForm({ assunto: "", mensagem: "" });
      setArquivo(null);
      if (inputFileRef.current) {
        inputFileRef.current.value = null;
      }
    } catch (error) {
      console.error("Erro ao enviar chamado:", error);
      alert("Ocorreu um erro ao enviar o chamado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={`form-container ${aberto ? "open" : ""}`}>
        <div className="form-header">
          <h5 className="modal-title">Ajuda e Suporte</h5>
          <button onClick={() => setAberto(false)}>X</button>
        </div>

        {user && (
          <p>
            <strong>Olá, {user.name}! Precisa de ajuda?</strong>
          </p>
        )}

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <input
            type="text"
            name="assunto"
            placeholder="Assunto"
            required
            value={form.assunto}
            onChange={handleChange}
          />
          <textarea
            name="mensagem"
            placeholder="Mensagem"
            rows="4"
            required
            value={form.mensagem}
            onChange={handleChange}
          />
          <input
            type="file"
            accept=".jpg,.jpeg,.pdf"
            onChange={handleFileChange}
            ref={inputFileRef}
          />
          <small style={{ display: "block", marginTop: "4px", color: "#555" }}>
            O arquivo deve ter no máximo 5MB e estar nos formatos .pdf, .jpeg ou
            .jpg
          </small>

          <button type="submit" className="enviar-btn mt-3" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Enviando...
              </>
            ) : (
              "Enviar"
            )}
          </button>
        </form>
      </div>

      <button className="botao-atendimento" onClick={() => setAberto(true)}>
        <MessageCircle /> Suporte
      </button>
      {chamadoCriado && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-4 text-center">
              <img
                src="assets/img/logo.png"
                alt="Logo Conecta SP"
                style={{ width: 100, margin: "0 auto 10px" }}
              />

              <h6 className="mb-1">Fundação Oncocentro de São Paulo</h6>
              <h6 className="mb-3">
                Secretaria da Saúde do Estado de São Paulo
              </h6>

              <h5 className="fw-bold text-success mb-2">
                Seu chamado foi registrado com sucesso na plataforma Conecta SP.
              </h5>

              <p className="mb-4">
                Você receberá um e-mail com todos os detalhes do chamado.
              </p>

              <div className="text-start mb-3">
                <div className="row">
                  <div className="col-md-3"></div>
                  <div className="col-md-6 text-start mb-3">
                    <div className="d-flex mb-2">
                      <div style={{ width: "160px", fontWeight: "bold" }}>
                        Número do chamado:
                      </div>
                      <div>{chamadoCriado.numeroChamado}</div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ width: "160px", fontWeight: "bold" }}>
                        Status:
                      </div>
                      <div>{chamadoCriado.nomeStatus}</div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ width: "160px", fontWeight: "bold" }}>
                        Data de abertura:
                      </div>
                      <div>
                        {new Date(chamadoCriado.dataAbertura).toLocaleString(
                          "pt-BR",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ width: "160px", fontWeight: "bold" }}>
                        Solicitante:
                      </div>
                      <div>{chamadoCriado.nomeUsuario}</div>
                    </div>
                  </div>
                  <div className="col-md-3"></div>
                </div>
              </div>

              <p className="mb-3">
                Você será notificado por e-mail quando houver uma atualização no
                chamado.
              </p>

              <p className="fw-bold mb-0">
                Obrigado por utilizar o Conecta SP.
              </p>

              <div className="modal-footer border-0 justify-content-center mt-4">
                <button
                  className="btn btn-primary"
                  onClick={() => setChamadoCriado(null)}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BotaoSuporte;
